export class EnquiryConfig {
    constructor(options) {
        // init options
        {
            options.countCallback || (options.countCallback = options.countUrl ? post(options.countUrl) : throwError("Please specify countUrl or countCallback in options!"));
            options.accosCallback || (options.accosCallback = options.accosUrl ? post(options.accosUrl) : throwError("Please specify accosUrl or accosCallback in options!"));
            options.saveCallback || (options.saveCallback = options.saveUrl ? post(options.saveUrl) : throwError("Please specify saveUrl or saveCallback in options!"));
            options.successCallback || (options.successCallback = options.successUrl ? post(options.successUrl) : () => Promise.resolve(undefined));
            options.trackStep || (options.trackStep = (name) => {
                const dataLayer = (window["dataLayer"] = window["dataLayer"] || []);
                dataLayer.push({
                    event: "enquirywidget",
                    step: name,
                    enquirytype: options.enquiryType,
                    enquirylang: options.language,
                    culture: options.culture,
                });
            });
            options.trackSuccess || (options.trackSuccess = (enquiryData, result) => {
                var _a;
                const dataLayer = (window["dataLayer"] = window["dataLayer"] || []);
                var enquirytype = enquiryData.enquiryType == 1 ? "general" : "direct";
                var transactionId = enquiryData.enquiryType == 1 ? `A${result.enquiryStageId}` : `D${result.enquiryStageId}`;
                var products = (_a = result.companies) === null || _a === void 0 ? void 0 : _a.map((_) => ({
                    item_id: _.companyId.toString(),
                    item_name: _.gaqLabel,
                    item_category: enquirytype,
                    price: 1,
                    quantity: 1,
                    currency: 'EUR',
                }));
                dataLayer.push({
                    event: "enquiry",
                    enquirytype: enquirytype,
                    enquirylang: enquiryData.language,
                    culture: options.culture,
                    transactionId: transactionId,
                    // GA-4
                    transactionItems: products,
                    // UA (this will be deleted soon)
                    transactionProducts: products === null || products === void 0 ? void 0 : products.map((_) => ({
                        sku: _.item_id,
                        name: _.item_name,
                        category: _.item_category,
                        price: _.price,
                        quantity: _.quantity,
                    })),
                });
                try {
                    window["fbq"]("track", "Lead");
                }
                catch (e) {
                    // adblocker
                }
            });
            options.trackStep = catchErrors(options.trackStep);
            options.trackSuccess = catchErrors(options.trackSuccess);
        }
        Object.assign(this, options);
        function catchErrors(cb) {
            return (...args) => {
                try {
                    return cb(...args);
                }
                catch (e) {
                    console.error(e);
                }
            };
        }
        function throwError(msg) {
            return () => {
                throw new Error(msg);
            };
        }
        function post(url) {
            return async (json, signal) => {
                const result = await fetch(url, {
                    method: "POST",
                    cache: "no-cache",
                    credentials: "include",
                    headers: { "Content-Type": "application/json" },
                    signal,
                    body: JSON.stringify(json),
                });
                const obj = await result.json();
                return obj;
            };
        }
    }
}
;
